import { render, staticRenderFns } from "./history-list.vue?vue&type=template&id=46cba0a4&scoped=true"
import script from "./history-list.vue?vue&type=script&lang=ts"
export * from "./history-list.vue?vue&type=script&lang=ts"
import style0 from "./history-list.vue?vue&type=style&index=0&id=46cba0a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46cba0a4",
  null
  
)

export default component.exports